
export const faqsContent = [
  {
    title: 'Which Insurance company would I be under?',
    content: (
      <div className='my-2 space-y-2'>
        As a private exchange broker, we are contracted with multiple insurance companies. You may have to qualify
        for the plan and undergo a routine health underwriting process. The underwriting process will determine
        which Insurance company best matches your needs.
      </div>
    )
  },

  {
    title: 'Do you provide full health coverage?',
    content: (
      <div className='my-2 space-y-2'>
        Our health insurance plan provides full benefits. It may differ from what you are accustomed to because
        we created a package that provides comprehensiveness at lower rates. We are providing alternative
        solutions to the public who are looking for a provider with similar benefits to the market exchange but for
        more affordable prices.
      </div>
    )
  },
  {
    title: 'Can I choose my own doctor?',
    content: (
      <div className='my-2 space-y-2'>
        You can choose from two of the largest networks in the country, which are First Health and PHCS Multi-Plan.
        All plans are PPO network.
      </div>
    )
  },
  {
    title: 'Which tier covers generic and brand name prescriptions? Is there a copay for prescription medications?',
    content: (
      <div className='my-2 space-y-2'>
        Our policy provides coverage for prescriptions for both generic and brand name medication. With the
        combination of network discounts and reimbursements, generic prescriptions cost $10 on average and brand
        name $20 on average. Some brand names are expensive and may cost more than $20. If so, we recommend
        going back to the doctor to see if there is an alternative prescript
      </div>
    )
  },
  {
    title: 'Is there a one-year commitment? If so, when can I drop the plan?',
    content: (
      <div className='my-2 space-y-2'>
        We are so confident that you will be happy with your plan that our policies do not require any long-term
        commitment. This means that you can cancel anytime. Unlike other insurance companies, our insurance
        companies cannot cancel you regardless of how many claims you have. We cannot cancel you, but you can
        cancel us. That’s confidence that you will be happy with our product.
      </div>
    )
  },
];